import { render, staticRenderFns } from "./CustomerCredit.vue?vue&type=template&id=c2537a90&"
import script from "./CustomerCredit.vue?vue&type=script&lang=js&"
export * from "./CustomerCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports